module.exports = __webpack_public_path__ + "img/list.8afa325f.svg";